import React from 'react';

const NebulaPositionsFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaPositionsModalRegistry = {
    personalize_nebulaPositionsId: NebulaPositionsFormModal
};
export default nebulaPositionsModalRegistry;
